import { render, staticRenderFns } from "./diariodeBordo.vue?vue&type=template&id=a7f06006&scoped=true&"
import script from "./diariodeBordo.vue?vue&type=script&lang=js&"
export * from "./diariodeBordo.vue?vue&type=script&lang=js&"
import style0 from "./diariodeBordo.vue?vue&type=style&index=0&id=a7f06006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f06006",
  null
  
)

export default component.exports